import React, { useState } from 'react';
import {
    Box,
    TextField,
    Typography,
    Button,
    CircularProgress
} from '@mui/material';
import { useHistory } from 'react-router-dom';

export const LoginCustomer = () => {
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const [formData, setFormData] = useState({
        merchantId: '',
        email: '',
        phone: ''
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        // Handle form submission here.
        setLoading(false);
    };

    const handleClear = () => {
        setFormData({
            merchantId: '',
            email: '',
            phone: ''
        });
    };

    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="flex-start"
            height="100vh"
            paddingTop="20px"
        >
            <Box
                width="100%"
                maxWidth="500px"
                padding="20px"
                backgroundColor="#fff"
                borderRadius="8px"
                boxShadow="0 4px 8px rgba(0, 0, 0, 0.2)"
                border="1px solid rgba(0, 0, 0, 0.1)"
                paddingBottom="40px"
            >
                <Typography
                    variant="h5"
                    gutterBottom
                    align="center"
                    sx={{
                        fontWeight: 'bold',
                        textShadow: '1px 1px 2px rgba(0, 0, 0, 0.2)',
                        color: '#333'
                    }}
                >
                    LOGIN
                </Typography>
                <form onSubmit={handleLogin}>
                    <TextField
                        label="Merchant ID"
                        name="merchantId"
                        value={formData.merchantId}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Email ID"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />
                    <TextField
                        label="Phone Number"
                        name="phone"
                        value={formData.phone}
                        onChange={handleInputChange}
                        fullWidth
                        margin="normal"
                        required
                    />

                    <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="center"
                        mt={2}
                    >
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            width="100%"
                            mb={2}
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                onClick={handleClear}
                                style={{ flexGrow: 1, marginRight: 8 }}
                            >
                                Clear
                            </Button>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                style={{ flexGrow: 1 }}
                            >
                                {loading ? (
                                    <CircularProgress size={24} />
                                ) : (
                                    'Submit'
                                )}
                            </Button>
                        </Box>
                        <Typography
                            variant="body2"
                            color="textSecondary"
                            mb={2}
                            align="center"
                        >
                            If you are new, please register.
                        </Typography>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => {
                                history.push(
                                    '/LoanDistributor/CustomerRegistration'
                                );
                            }}
                            style={{ flexGrow: 1 }}
                        >
                            Register
                        </Button>
                    </Box>
                </form>
            </Box>
        </Box>
    );
};
